import AppResource from 'general/constants/AppResource';
import PropTypes from 'prop-types';
import { ReactBingmaps } from 'react-bingmaps';

Bingmap.propTypes = {
  name: PropTypes.string,
  longitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  latitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  zoom: PropTypes.number,
};

const bingmapOptions = {
  liteMode: true,
  showLocateMeButton: false,
  showMapTypeSelector: false,
  showScalebar: false,
  showTermsLink: false,
  showZoomButtons: false,
  showDashboard: false,
  showBreadcrumb: false,
  enableClickableLogo: false,
  customMapStyle: {
    elements: {
      water: { fillColor: '#a1e0ff' },
      waterPoint: { iconColor: '#a1e0ff' },
    },
    version: '1.0',
  },
};

function Bingmap({ name, longitude, latitude, zoom }) {
  // MARK: ---- PROPERTIES ----
  const longitudeNumber = parseFloat(longitude);
  const latitudeNumber = parseFloat(latitude);

  // Guard against NaN/Infinity which can crash Bing map rendering
  if (!Number.isFinite(latitudeNumber) || !Number.isFinite(longitudeNumber)) {
    return <div className="w-100 h-100" />;
  }

  return (
    <div
      style={{
        pointerEvents: 'none',
      }}
      className="w-100 h-100"
    >
      <ReactBingmaps
        key={`charge_station_map_key_${name ?? 'default'}`}
        id={`charge_station_map_id_${name ?? 'default'}`}
        mapOptions={bingmapOptions}
        bingmapKey={process.env.REACT_APP_BING_MAP_API_KEY}
        center={[latitudeNumber, longitudeNumber]}
        zoom={zoom}
        mapTypeId="grayscale"
        className="customClass"
        pushPins={[
          {
            location: [latitudeNumber, longitudeNumber],
            option: {
              icon: AppResource.icons.pin.normal,
            },
          },
        ]}
      />
    </div>
  );
}

export default Bingmap;
